import { SettingsConfigurations } from '@pulse/common';

export const pulseSettingsdefaultConfigs: SettingsConfigurations = {
    settingsBaseURL: 'https://optifyr.com/web/v2',
    timeout: 1500,
    cacheTimeout: 600000,
    defaults: {},
    attributes: {},
    storagePrefix: 'paa_',
    remoteSettingEnabled: true,
} as SettingsConfigurations;
